"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutMain = exports.MainSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const react_redux_1 = require("react-redux");
const antd_1 = require("antd");
const actions_1 = __importDefault(require("actions"));
const Header_1 = __importDefault(require("@src/components/modules/navigation/Header"));
const Footer_1 = require("@src/components/modules/navigation/Footer");
const cookie_consent_1 = __importDefault(require("components/modules/global/cookie-consent"));
const AccountAuthenticationModal_1 = require("@src/components/modules/AccountAuthenticationModal");
const elements_1 = require("@src/components/elements");
const auth_context_1 = require("@src/context/auth-context");
const Routes_1 = require("@src/router/Routes");
const react_router_1 = require("react-router");
const saved_offer_context_1 = require("@src/context/saved-offer-context");
const header_menu_context_1 = require("@src/context/header-menu-context");
const PremiumCompanyProfileSubscriptionModal_1 = require("@src/components/pages/admin/modules/company-subscription/PremiumCompanyProfileSubscriptionModal");
const premium_company_profile_modal_context_1 = require("@src/context/premium-company-profile-modal-context");
const BackToTop_1 = require("./BackToTop");
exports.MainSection = styled_components_1.default.div `
	flex: 1 0 auto;
	background: ${props => props.theme.color.background};
	${props => !props.withHero &&
    (0, styled_components_1.css) `
			padding-top: ${props.theme.size.headerHeight}px; /* to handle fixed header */
		`}
`;
const LayoutMain = props => {
    var _a;
    // @ts-ignore
    const cookieConsent = (0, react_redux_1.useSelector)(state => state.app.cookieConsent);
    const dispatch = (0, react_redux_1.useDispatch)();
    const location = (0, react_router_1.useLocation)();
    const { value: authContextValue, AuthContextProvider } = (0, auth_context_1.useAuthContextProvider)();
    const { value: savedOfferContextValue, SavedOffersContextProvider } = (0, saved_offer_context_1.useSavedOffersContextProvider)();
    const { value: headerMenuContextValue, HeaderMenuContextProvider } = (0, header_menu_context_1.useHeaderMenuContextProvider)();
    const { value: PremiumCompanyProfileModalContextValue, PremiumCompanyProfileModalContextProvider } = (0, premium_company_profile_modal_context_1.usePremiumCompanyProfileModalContextProvider)();
    const matchedTopLevelRoute = Routes_1.routes.find(routeObj => {
        const paths = Object.entries(routeObj.paths).map(([locale, path]) => locale !== 'sk' ? `/${locale}${path}` : path);
        const match = (0, react_router_1.matchPath)(location.pathname, {
            path: paths,
            exact: !routeObj.routes,
        });
        return Boolean(match);
    });
    return ((0, jsx_runtime_1.jsx)(AuthContextProvider, { value: authContextValue, children: (0, jsx_runtime_1.jsxs)(SavedOffersContextProvider, { value: savedOfferContextValue, children: [(0, jsx_runtime_1.jsxs)(PremiumCompanyProfileModalContextProvider, { value: PremiumCompanyProfileModalContextValue, children: [(0, jsx_runtime_1.jsx)(HeaderMenuContextProvider, { value: headerMenuContextValue, children: (0, jsx_runtime_1.jsxs)(antd_1.Layout, { children: [!cookieConsent && (0, jsx_runtime_1.jsx)(cookie_consent_1.default, { onAgree: () => dispatch(actions_1.default.cookieConsentStart()) }), (0, jsx_runtime_1.jsx)(elements_1.Head, {}), (0, jsx_runtime_1.jsx)(Header_1.default, { navigation: matchedTopLevelRoute === null || matchedTopLevelRoute === void 0 ? void 0 : matchedTopLevelRoute.props.navigation }), (0, jsx_runtime_1.jsx)(exports.MainSection, { withHero: (_a = matchedTopLevelRoute === null || matchedTopLevelRoute === void 0 ? void 0 : matchedTopLevelRoute.props.navigation) === null || _a === void 0 ? void 0 : _a.withHero, children: props.children }), (0, jsx_runtime_1.jsx)(Footer_1.Footer, {}), (0, jsx_runtime_1.jsx)(BackToTop_1.BackToTop, {})] }) }), (0, jsx_runtime_1.jsx)(PremiumCompanyProfileSubscriptionModal_1.PremiumCompanyProfileSubscriptionModal, {})] }), (0, jsx_runtime_1.jsx)(AccountAuthenticationModal_1.AccountAuthenticationModal, {})] }) }));
};
exports.LayoutMain = LayoutMain;
